import type { ScheduledPublication } from '../types';

/** Read the item receipt (list receipts are keyed by post ID). Never infer admission from status. */
export function scheduledPublicationMessage(status: string, value: unknown, scheduledFor?: string, postId?: string): string | null {
  if (status !== 'scheduled') return null;
  if (postId && value && typeof value === 'object') value = (value as Record<string, unknown>)[postId];
  const receipt = value && typeof value === 'object' && 'state' in value ? value as ScheduledPublication : undefined;
  const due = receipt?.due ?? scheduledFor;
  const time = due ? ` Requested time: ${due}.` : '';
  if (receipt?.state === 'claimed') return `Publication is being processed. Completion is not confirmed.${time}`;
  if (receipt?.admitted === true && receipt.state === 'pending') {
    return receipt.enabled === true
      ? `Automatic publication is scheduled.${time}`
      : `Schedule saved · automatic publication paused.${time}`;
  }
  return `Automatic publication is not confirmed. Reopen this post and confirm a future schedule.${time}`;
}

export function isScheduleNotRecorded(error: unknown): boolean {
  return !!error && typeof error === 'object' && 'data' in error &&
    (error.data as { code?: string } | undefined)?.code === 'SCHEDULE_NOT_RECORDED';
}
